export function formatCurrency(value: number, locale = 'pt-BR', currency = 'BRL') {
  if (value == null || isNaN(value)) return 'R$ 0,00';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(value);
}
